import Logo from "./Logo";
import React, { useState, useEffect } from 'react';

export default function intersperseWithLogo(text='', tagType, color = '#000000') {
    if (!text || typeof text !== 'string') {
        return [];
    }
    const parts = text.split('spleen*');
    const result = [];

    let height;
    let margin;
    switch(tagType) {
        case 'h1':
                height = '56px';
                margin = '0';
            break;
        case 'h2':
            height = '40px';
            margin = '2px';
            break;
        case 'h3':
            height = '30px';
            margin = '0px';
            break;
        case 'h4':
            height = '25px';
            margin = '2px';
            break;
        case 'xl':
            height = '22px';
            margin = '2px';
            break;
        case 'h5':
            height = '13px';
            margin = '5px';
            break;
        case 'h6':
            height = '12px';
            margin = '5px';
            break;
        case 'p':
            height = '25px';
            margin = '3px';
            break;
        case 'button':
            height = '10px';
            margin = '3px';
            break;
        default:
            height = 'h-full';
    }

    parts.forEach((part, index) => {
        result.push(part);
        if(index !== parts.length - 1) {
            result.push(<Logo height={height} margin={margin} key={index} color={color} />);
        }
    });
    return result;
}
